const PE_TRANSLATION_FIELDS = [
    'name', 
    'description',
];

export default PE_TRANSLATION_FIELDS;
